import React from "react";

import Image from "../components/image";
import { getSourceImageUrlToCGI } from "../utils/base";

function MyGallery({
  allWpMediaItem,
  containerClass = "pt-1",
  innerContainerClass = "flex justify-center mx-auto",
  galleryOuterClass = "mx-auto my-1",
  galleryInnerContainerClass = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-3"
}) {
  return (
    <>
      <section className={containerClass}>
        <div className={innerContainerClass}>
          <div className={galleryOuterClass}>
            <div className={galleryInnerContainerClass}>
              {allWpMediaItem?.map((imageItem, index) => {
                const { imageAlt, localFile: imageSrc, sourceUrl } = imageItem;
                return (
                  <div className="w-full h-auto sm:h-96" key={index}>
                    <Image
                      imageAlt={imageAlt ?? ""}
                      image={""}
                      imageClass="object-cover w-full h-full"
                      sourceUrl={getSourceImageUrlToCGI({
                        uri: imageSrc?.extension
                          ? imageSrc.publicURL
                          : sourceUrl
                      })}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default MyGallery;
